import { Component, OnInit } from '@angular/core'
import { ApiService } from '../../../shared/services/api.service'
import { Collection } from '../../../shared/interfaces/collection.interface'
import { AdminService } from '../../../shared/services/admin/admin.service'
import { Router } from '@angular/router'
import * as moment from 'moment'

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {

  collectionsCount = 10
  loadingCollections = false
  collections: Collection[] = []
  statistics = []
  chartReady = false
  chartData = {
    datasets: [],
    labels: [],
    colors: []
  }
  colors = {
    viewsPerDay: { // blue
      backgroundColor: 'rgba(32, 79, 112, 0.2)',
      borderColor: 'rgba(32, 79, 112, 1)',
      pointBackgroundColor: 'rgba(148,159,177,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(32, 79, 112, 0.8)'
    },
    palettesPerDay: { // green
      backgroundColor: 'rgba(173, 167, 29, 0.2)',
      borderColor: 'rgba(173, 167, 29, 1)',
      pointBackgroundColor: 'rgba(148,159,177,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(173, 167, 29, 0.8)'
    },
    newPalettesPerDay: { // green
      backgroundColor: 'rgba(32, 112, 44, 0.2)',
      borderColor: 'rgba(32, 112, 44, 1)',
      pointBackgroundColor: 'rgba(148,159,177,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(32, 112, 44, 0.8)'
    }
  }

  constructor(private apiService: ApiService,
              private admin: AdminService,
              private router: Router) {
  }

  ngOnInit() {
    this.admin.isAuthorized()
      .subscribe((a: any) => {
        if (!a.admin) {
          this.router.navigate(['/admin/login'])
        } else {
          this.loadCollections()
        }
      })

    const numberStats = ['views', 'palettes']
    numberStats.forEach(s => {
      this.apiService.getStatistics(s)
        .subscribe(_stats => this.pushStats(_stats, s))
    })

    const curveStats = ['viewsPerDay', 'palettesPerDay', 'newPalettesPerDay']
    const statsReady = []
    curveStats.forEach(s => {
      this.apiService.getStatistics(s, {
        from: moment().subtract(1, 'month').format('YYYY-MM-DD'),
        to: moment().format('YYYY-MM-DD')
      })
        .subscribe(stats => {
          this.pushCurveStats(stats, s)

          statsReady.push(s)
          if (statsReady.length === curveStats.length) {
            this.chartReady = true
          }
        })
    })
  }

  pushStats(stats, value: string) {
    for (const s in stats) {
      if (!stats.hasOwnProperty(s)) {
        continue
      }

      this.statistics.push({
        key: this.getDescriptionForKey(s, value),
        value: stats[s]
      })
    }
  }

  pushCurveStats(stats, key: string) {
    const index = this.chartData.datasets.length
    this.chartData.datasets.push({data: [], label: this.getDescriptionForCurve(key)})
    this.chartData.colors.push(this.colors[key])
    console.log(this.chartData.colors)

    for (const s in stats) {
      if (!stats.hasOwnProperty(s)) {
        continue
      }

      this.chartData.datasets[index].data.push(stats[s])

      const lbl = moment(s).format('YYYY-MM-DD')
      if (!this.chartData.labels.includes(lbl)) {
        this.chartData.labels.push(lbl)
      }
    }
  }

  getDescriptionForCurve(c: string) {
    switch (c) {
      case 'viewsPerDay': return 'views per day'
      case 'palettesPerDay': return 'palettes total'
      case 'newPalettesPerDay': return 'palettes created'
    }
  }

  getDescriptionForKey(k: string, s: string) {
    switch (s) {
      case 'views':
      {
        switch (k) {
          case 'last24hours':
            return 'Total views last 24 hours'
          case 'last7days':
            return 'Total views last 7 days'
          case 'lastMonth':
            return 'Total views last month'
          case 'prevMonth':
            return 'Total views the month before'
          default:
            return k
        }
      }
      case 'palettes':
      {
        switch (k) {
          case 'last24hours':
            return 'Palettes created last 24 hours'
          case 'last7days':
            return 'Palettes created last 7 days'
          case 'lastMonth':
            return 'Palettes created last month'
          case 'prevMonth':
            return 'Palettes created the month before'
          case 'total':
            return 'Total number of palettes'
          default:
            return k
        }
      }
    }
  }

  loadCollections() {
    this.loadingCollections = true
    this.apiService.getCollections()
      .subscribe((c: Collection[]) => {
        this.loadingCollections = false
        this.collections = c
      })
  }

  showMoreCollections() {
    this.collectionsCount += 10
  }

  deleteCollection(c: Collection) {
    this.apiService.deleteCollection(c)
      .subscribe(() => {
        this.loadCollections()
      })
  }

}



// WEBPACK FOOTER //
// C:/Users/Thomas/Projekte/palettes/src/app/admin/containers/admin/admin.component.ts